// @flow
import * as React from 'react';
import type { MapStateToProps } from 'react-redux';
import { connect } from 'react-redux';

import { capitalize, changeView } from '../calendar.model.js';

import {
  AIR_EVENT_TYPE,
  DAY,
  EVENT_ADD,
  EVENT_VIEW,
  INSTRUCTORS_SCHEDULE,
  MAINTENANCE_EVENT_TYPE,
  modalsNames,
  MONTH,
  WEEK
} from '../calendar.consts.js';
import { ADD_PASSENGER, EDIT_PASSENGER } from '../weight-and-balance/weight-and-balance.consts';

type Props = {|
  URL: URL,
  switchModals: Function
|};

class EventModalHeader extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.handleOutOfToggleClick = this.handleOutOfToggleClick.bind(this);
    this.handleToggleClick = this.handleToggleClick.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.state = { toggleOpen: false };
  }

  handleOutOfToggleClick: Function;
  handleOutOfToggleClick() {
    this.toggle.blur();
  }

  handleToggleClick: Function;
  handleToggleClick(e) {
    e.preventDefault();
    this.toggle.focus();
  }

  handleFocus: Function;
  handleFocus() {
    this.setState({ toggleOpen: true });
  }

  handleBlur: Function;
  handleBlur() {
    this.setState({ toggleOpen: false });
  }

  render() {
    const { URL, eventForm, locations, instructor, userFilters, filterForm } = this.props;

    return (
      <div
        className="panel-heading"
        onClick={this.state.toggleOpen ? this.handleOutOfToggleClick : null}
      >
        <div className="modal-breadcrumbs change-event-type">
          <a
            className={URL.eventBreadcrumbs.length > 1 ? 'underline' : 'no-underline'}
            onClick={
              URL.eventBreadcrumbs.length
                ? () =>
                    this.props.switchModals(URL.eventBreadcrumbs[0].action, undefined, [
                      URL.eventBreadcrumbs[0]
                    ])
                : null
            }
          >
            <span
              className={`
                icon
                ${eventForm.type === AIR_EVENT_TYPE ? 'plane-air' : ''}
                ${eventForm.type === MAINTENANCE_EVENT_TYPE ? 'maintenance' : ''}
              `}
            />
            <span>
              {URL.eventBreadcrumbs[0].action === INSTRUCTORS_SCHEDULE &&
              instructor.id &&
              locations[instructor.locationID]
                ? `Instructor's Schedule for ${locations[instructor.locationID].locationName}`
                : URL.eventBreadcrumbs[0].action === EVENT_ADD ||
                  URL.eventBreadcrumbs[0].action === EVENT_VIEW
                ? eventForm.addToWaiting === '1' && URL.eventBreadcrumbs[0].action === EVENT_ADD
                  ? modalsNames[URL.eventBreadcrumbs[0].action].addToWaiting
                  : modalsNames[URL.eventBreadcrumbs[0].action][eventForm.type]
                : modalsNames[URL.eventBreadcrumbs[0].action]}
            </span>
          </a>
          {URL.eventBreadcrumbs.length
            ? URL.eventBreadcrumbs.slice(1).map((breadcrumb, i) => (
                <span key={`${breadcrumb.action}-${i}`}>
                  {i !== URL.eventBreadcrumbs.length - 1 ? (
                    <span className="breadcrumbs-separator">/</span>
                  ) : null}
                  <a
                    className={i !== URL.eventBreadcrumbs.length - 2 ? 'underline' : 'no-underline'}
                    onClick={
                      i !== URL.eventBreadcrumbs.length - 2
                        ? () =>
                            this.props.switchModals(
                              breadcrumb.action,
                              undefined,
                              URL.eventBreadcrumbs.slice(0, i + 2)
                            )
                        : null
                    }
                  >
                    <span>
                      {breadcrumb.action === INSTRUCTORS_SCHEDULE &&
                      instructor.id &&
                      locations[instructor.locationID]
                        ? `Instructor's Schedule for ${locations[instructor.locationID].locationName}`
                        : `${modalsNames[breadcrumb.action]}`}
                    </span>
                  </a>
                </span>
              ))
            : null}
        </div>

        <div className="modal-controls-right modal-controls-right-view">
          {URL.eventParams.action === EVENT_VIEW ? (
            <div className="share-link-modal">
              <a
                className="icon-only"
                href={`${URL.org}/calendar/exportEvent/${URL.eventParams.event}/${URL.timezone}/`}
                title="Export Calendar"
              >
                <span className="icon share-link" />
              </a>
            </div>
          ) : null}

          {URL.eventParams.action === EVENT_VIEW ? (
            <div className="modal-controls-separator" />
          ) : null}

          {![INSTRUCTORS_SCHEDULE, ADD_PASSENGER, EDIT_PASSENGER].includes(
            URL.eventParams.action
          ) ? (
            <div className="modal-dropdown">
              <a
                ref={a => (this.toggle = a)}
                tabIndex="0"
                role="button"
                className="modal-dropdown-toggle"
                onClick={this.handleToggleClick}
                onTouchEnd={this.handleToggleClick}
                onFocus={this.handleFocus}
                onBlur={!/Mobi/.test(window.navigator.userAgent) ? this.handleBlur : null}
              >
                {`${capitalize(URL.action)} View`}
              </a>
              <span className="modal-dropdown-toggle-after" onClick={this.handleOutOfToggleClick} />
              {filterForm !== null && (
                <ul className="modal-dropdown-view">
                  <li className={`text-center modal-dropdown-view-item ${
                    URL.action === DAY ? 'active' : ''}`}
                  >
                    <a href={changeView(DAY, this.props.URL, filterForm, userFilters[filterForm.id])}>
                      Day View
                    </a>
                  </li>
                  <li className={`text-center modal-dropdown-view-item ${
                      URL.action === WEEK ? 'active' : ''}`}>
                    <a href={changeView(WEEK, this.props.URL, filterForm, userFilters[filterForm.id])}>
                      Week View
                    </a>
                  </li>
                  <li
                    className={`text-center modal-dropdown-view-item ${
                      URL.action === MONTH ? 'active' : ''}`}>
                    <a href={changeView(MONTH, this.props.URL, filterForm, userFilters[filterForm.id])}>
                      Month View
                    </a>
                  </li>
                </ul>
              )}
            </div>
          ) : null}
          <div className="modal-controls-separator" />
        </div>
      </div>
    );
  }
}

const mapStateToProps: MapStateToProps<ReduxState, OwnProps, MappedState> = state => ({
  URL: state.URL,
  locations: state.locations,
  instructor: state.instructor,
  filterForm: state.filterForm,
  userFilters: state.userFilters,
  eventForm: state.eventForm
});

export default connect(
  mapStateToProps,
  {}
)(EventModalHeader);
